import type { AppStrings } from './types.js';
import { plural } from './plural.js';

export const it: AppStrings = {
  // COMMON
  error_title: 'Errore',
  cancel: 'Annulla',
  retry: 'Riprova',
  back_arrow: '← Indietro',

  // ASK SCREEN
  ask_box_unavailable: 'Box non disponibile',
  ask_box_unavailable_desc: 'Il link potrebbe essere scaduto o il proprietario ha chiuso il suo box.',
  ask_create_own_box: 'Crea il tuo box',
  ask_sent_title: 'Inviato ✅',
  ask_sent_desc: 'La tua domanda anonima è stata consegnata al proprietario del box.',
  ask_anonymous_hint: 'La tua domanda sarà inviata in modo anonimo.',
  ask_placeholder: 'Scrivi la tua domanda…',
  ask_send: 'Invia',
  ask_sending: 'Invio…',
  ask_error_rate_limit: 'Troppe richieste — aspetta un momento.',
  ask_error_restart: 'Per favore riavvia la Mini App.',
  ask_error_load: 'Impossibile caricare il box.',
  ask_error_send: 'Impossibile inviare la domanda.',
  ask_error_banned: 'Sei stato bloccato nell\'app.',
  ask_banned_appeal_btn: 'Fai ricorso',
  ask_appeal_sent: 'Ricorso inviato. Lo esamineremo manualmente.',

  // AGE GATE
  age_gate_title: 'Solo maggiorenni (18+)',
  age_gate_desc:
    'Stai inviando una domanda anonima. Sii rispettoso: sono vietati molestie, minacce, contenuti sessuali che coinvolgono minori e qualsiasi contenuto illegale. L\'anonimato non implica impunità — le violazioni vengono segnalate alla moderazione. Inviando una domanda, confermi di avere 18+ e accetti le regole.',
  age_gate_confirm: 'Ho 18+ — continua',

  // INBOX SCREEN
  inbox_title: 'Il tuo box',
  box_link_accordion: 'Link di invito',
  inbox_notifications_ask: '🔔 Vuoi ricevere notifiche dal bot per le nuove domande?',
  inbox_notifications_allow: 'Consenti',
  inbox_notifications_dismiss_label: 'Ignora',
  inbox_box_toggle_disable: 'Disattiva domande',
  inbox_box_toggle_enable: 'Attiva domande',
  inbox_box_disabled_warning: 'Le domande sono disattivate — non verranno accettate nuove domande.',
  inbox_share_hint: 'Condividi il link per far sì che i tuoi amici ti facciano domande anonime.',
  inbox_copy: 'Copia',
  inbox_copied: 'Copiato',
  inbox_copy_error: 'Errore',
  inbox_no_deeplink: 'Il link apparirà dopo il deploy.',
  inbox_invite_story: 'Invita tramite Story',
  inbox_invite_chat: 'Invita tramite chat',
  inbox_card_rendering: 'La card di invito è ancora in elaborazione.',
  inbox_story_unsupported:
    'Le Stories non sono disponibili in questa versione di Telegram. Prova "tramite chat".',
  inbox_story_error: 'Impossibile aprire la Story.',
  inbox_chat_unsupported:
    'La condivisione via chat non è disponibile in questa versione di Telegram. Aggiorna il client.',
  inbox_chat_error: 'Impossibile condividere. Riprova.',
  inbox_chat_prepare_error: 'Impossibile preparare l\'invito.',
  inbox_filter_incoming: 'In arrivo',
  inbox_filter_hidden: 'Nascoste',
  inbox_filter_blocked: 'Bloccate',
  inbox_filter_empty: 'Ancora niente qui.',
  inbox_acc_unanswered: 'Senza risposta',
  inbox_acc_answered: 'Con risposta',
  inbox_acc_hidden: 'Nascoste',
  inbox_acc_blocked: 'Bloccate',
  inbox_empty: 'Ancora nessuna domanda. Condividi il link qui sopra.',
  inbox_load_more: 'Carica altro',
  inbox_load_more_error: 'Impossibile caricare la pagina successiva.',
  inbox_error_load: 'Impossibile caricare il box.',
  inbox_rate_limit: 'Troppe richieste — aspetta un momento.',
  inbox_toggle_error: 'Impossibile cambiare lo stato del box.',

  // MESSAGE BOX (Трек D)
  message_tagline: 'Scrivimi in modo anonimo',
  message_placeholder: 'Scrivi un messaggio…',
  message_anonymous_hint: 'Il tuo messaggio sarà inviato in modo anonimo.',
  message_sent_title: 'Inviato ✅',
  message_sent_desc: 'Il tuo messaggio anonimo è stato consegnato.',
  message_owner_entry: 'Scrivimi',
  message_share_hint: 'Condividi il link per far sì che chiunque possa inviarti un messaggio anonimo.',
  message_inbox_open: 'Messaggi ricevuti',
  message_inbox_title: 'Messaggi',
  message_inbox_empty: 'Ancora nessun messaggio. Condividi il tuo link qui sopra.',

  // ANSWER SCREEN
  answer_title: 'Rispondi alla domanda',
  answer_placeholder: 'Scrivi la tua risposta…',
  answer_submit: 'Invia',
  answer_submitting: 'Invio…',
  answer_back: 'Indietro',
  answer_error_send: 'Impossibile inviare la risposta.',

  // SHARE SCREEN
  share_title: 'Risposta pubblicata ✅',
  share_hint: 'Condividi la card e ricevi ancora più domande.',
  share_card_rendering_desc:
    'La card è ancora in elaborazione. Torna alle domande e ricontrolla tra poco — potrai condividerla in una Story o via chat.',
  share_card_alt: 'Card risposta',
  share_story_btn: 'Condividi in Story',
  share_story_btn_busy: 'Apertura…',
  share_chat_btn: 'Condividi in chat',
  share_chat_btn_busy: 'Preparazione…',
  share_back: 'Torna alle domande',
  share_story_unsupported:
    'Le Stories non sono disponibili in questa versione di Telegram. Prova "Condividi in chat".',
  share_story_error: 'Impossibile aprire la Story. Prova "Condividi in chat".',
  share_chat_sent: 'Messaggio inviato.',
  share_chat_unsupported:
    'La condivisione via chat non è disponibile in questa versione di Telegram. Aggiorna il client.',
  share_chat_error: 'Impossibile condividere. Riprova.',
  share_chat_prepare_error: 'Impossibile preparare il messaggio.',

  // LEADERBOARD SCREEN
  lb_title: 'Classifica',
  lb_period_7d: '7 giorni',
  lb_period_30d: '30 giorni',
  lb_period_all: 'Da sempre',
  lb_group_label: 'Categoria',
  lb_group_all: 'Tutti',
  lb_group_ask: 'Domande',
  lb_group_rate: 'Valutazioni',
  lb_group_confession: 'Confessioni',
  lb_group_guesswho: 'Indovina chi',
  lb_group_message: 'Messaggi',
  lb_error: 'Impossibile caricare la classifica',
  lb_empty: 'Nessuno in classifica ancora',
  lb_anon: 'Anonimo',
  lb_load_more: 'Carica altro',
  lb_questions: (n) => plural('it', n, { one: '{n} domanda', other: '{n} domande' }),
  lb_referrals: (n) => plural('it', n, { one: '{n} ref.', other: '{n} refs.' }),

  // REWARDS SCREEN
  rw_title: 'I miei premi',
  rw_error: 'Impossibile caricare i premi',
  rw_level: (n) => `Livello ${n}`,
  rw_confirmed_referrals: (n) =>
    plural('it', n, { one: '{n} referral confermato', other: '{n} referral confermati' }),
  rw_next_level_section: (n) =>
    plural('it', n, { one: 'PROSSIMO LIVELLO — {n} referral', other: 'PROSSIMO LIVELLO — {n} referral' }),
  rw_to_level: (level, target) => `al livello ${level}: ${target}`,
  rw_max_level: 'Livello massimo raggiunto!',
  rw_badges_section: 'BADGE',
  rw_formats_section: 'FORMATI BOX',

  // QUESTION CARD
  qcard_status_new: 'Nuova',
  qcard_status_hidden: 'Nascosta',
  qcard_status_answered: 'Risposta data',
  qcard_moderation_flagged: 'Attenzione: messaggio sospetto',
  qcard_answer_btn: 'Rispondi',
  qcard_answer_send: 'Invia',
  qcard_share_btn: 'Condividi',
  qcard_hide_btn: 'Nascondi',
  qcard_show_btn: 'Mostra',
  qcard_report_btn: 'Segnala',
  qcard_block_btn: 'Blocca',
  qcard_unblock_btn: 'Sblocca',
  qcard_report_reason_label: 'Seleziona il motivo della segnalazione:',
  qcard_reason_spam: 'Spam',
  qcard_reason_harassment: 'Molestie',
  qcard_reason_sexual: 'Contenuto sessuale',
  qcard_reason_other: 'Altro',
  qcard_error_hide: 'Impossibile modificare la visibilità.',
  qcard_error_report: 'Impossibile inviare la segnalazione.',
  qcard_error_block: 'Impossibile bloccare il mittente.',
  qcard_report_done: 'Segnalazione inviata — grazie.',
  qcard_block_done: 'Mittente bloccato.',
  qcard_unblock_done: 'Mittente sbloccato.',

  // ERRORS
  err_network: 'Nessuna connessione al server. Controlla la tua connessione e riprova.',
  err_server_unavailable: 'Il server è temporaneamente non disponibile, riprova più tardi.',
  err_internal: 'Qualcosa è andato storto da parte nostra. Ci stiamo occupando — riprova più tardi.',
  err_bad_request: 'Controlla i dati che hai inserito.',
  err_generic: 'Impossibile completare l\'azione, riprova più tardi.',
  err_schema: 'Errore nei dati. Prova ad aggiornare l\'app.',
  share_story_link_premium_note:
    'Un link cliccabile nelle Stories richiede Telegram Premium. Senza di esso, i tuoi amici possono comunque trovarti — il tuo username è mostrato nella card.',

  // AUTH ERROR SCREEN
  auth_error_title: 'Errore di accesso',
  auth_error_desc:
    'Autenticazione fallita. Chiudi e riapri la Mini App da Telegram.',

  // REWARD TOAST
  reward_toast_title: 'Nuovo premio!',
  reward_toast_close: '×',

  // BOTTOM TABBAR
  tab_questions: 'Domande',
  tab_leaderboard: 'Classifica',
  tab_rewards: 'Premi',
  tab_settings: 'Impostazioni',

  // SETTINGS SCREEN
  settings_title: 'Impostazioni',
  settings_section_general: 'Generale',
  settings_notifications: 'Notifiche per le nuove domande',
  settings_notifications_hint: 'Il bot ti avviserà quando qualcuno ti fa una domanda.',
  settings_notifications_error: 'Impossibile salvare le impostazioni di notifica.',
  settings_language: 'Lingua',
  settings_language_error: 'Impossibile cambiare la lingua. Riprova.',
  settings_section_about: 'Informazioni',
  settings_version: 'Versione',

  // CODE ENTRY (work-020)
  code_modal_title: 'I link nelle Stories sono solo per Premium',
  code_modal_explain:
    'Telegram dà un link cliccabile nelle Stories solo agli abbonati Premium. In alternativa, aggiungi il tuo codice alla story — i visitatori lo digitano nell\'app e ti fanno una domanda anonima.',
  code_modal_your_code: 'Il tuo codice',
  code_modal_copy: 'Copia codice',
  code_modal_copied: 'Copiato',
  code_modal_share_btn: 'Condividi in story',
  code_modal_loading: 'Recupero del codice…',
  code_modal_error: 'Impossibile ottenere il tuo codice. Riprova più tardi.',
  ask_code_title: 'Inserisci un codice',
  ask_code_desc:
    'Sei arrivato da una story? Trova il codice in essa (es. 1234) e digitalo qui sotto.',
  ask_code_placeholder: 'Codice dalla story',
  ask_code_find: 'Cerca',
  ask_code_not_found: 'Codice non trovato. Controlla le cifre e riprova.',
  ask_code_invalid: 'Il codice è di 4 cifre.',
  code_onboarding_header: 'Sei arrivato da una story?',
  code_onboarding_text: 'Inserisci il codice di un amico per fargli una domanda anonima.',
  code_onboarding_action: 'Inserisci codice',
  settings_ask_by_code: 'Chiedi tramite codice',
  settings_my_code_title: 'Il tuo codice per le stories',
  settings_my_code_hint:
    'Scrivi questo codice nella tua story — i visitatori lo inseriscono per farti una domanda anonima. Telegram riserva i link cliccabili nelle Stories agli abbonati Premium.',
  settings_my_code_rotate: 'Ottieni un nuovo codice',
  settings_my_code_rotating: 'Aggiornamento…',
  settings_my_code_done: 'Codice aggiornato',
  settings_my_code_error: 'Impossibile ottenere il tuo codice.',
  settings_my_code_rotate_confirm_title: 'Cambiare codice?',
  settings_my_code_rotate_confirm_desc:
    'Il tuo vecchio codice smette di funzionare subito. Chi l\'ha visto nella tua storia non potrà più scriverti. Cambialo solo se qualcuno ti sta spammando.',
  settings_my_code_rotate_confirm_action: 'Cambia codice',

  // BOT
  bot_greeting: (name) => (name ? `Ciao, ${name}! 👋` : 'Ciao! 👋'),
  bot_onboarding:
    'Questo è VeylMe — domande anonime.\n\n' +
    'Apri la Mini App, pubblica una card «Chiedimi in modo anonimo» nella tua Story — ' +
    'e ricevi domande anonime direttamente qui.\n\n' +
    '⚠️ 18+. Sii rispettoso: bullismo, minacce e contenuti vietati ' +
    'non sono ammessi. Anonimato ≠ impunità — le violazioni vanno alla moderazione.',
  bot_open_btn: 'Apri VeylMe',
  notify_answer_btn: 'Rispondi',
  bot_invite_text:
    'Qualcuno ha condiviso un link VeylMe.\n\n' +
    'Apri la Mini App per fare una domanda anonima:',
  bot_invite_btn: 'Chiedi in modo anonimo',

  // WORK-027 i18n sweep
  tagline: 'Chiedimi in modo anonimo',
  share_ask_action: 'Chiedi',
  share_answered_text: 'Ho risposto a una domanda anonima 👀',
  err_not_in_telegram: 'La Mini App non è in esecuzione in Telegram. Riavvia l\'app.',
  badge_viral_starter: 'Partenza virale',
  badge_storyteller: 'Narratore',
  badge_loop_master: 'Maestro del ciclo',
  theme_confession: 'Confessioni',
  theme_guesswho: 'Indovina chi',
  rw_format_named: (name) => `formato «${name}»`,
  card_label_question: 'Domanda',
  card_label_answer: 'Risposta',
  card_invite_subtitle: 'anonimo, senza registrazione',
  card_code_hint: 'INSERISCI IL CODICE NELL\'APP',
  share_msg_title: (brand) => `${brand} · Domande anonime`,
  notify_new_question: '🔔 Qualcuno ti ha fatto una domanda anonima',
  notify_unanswered_reminder: (n) =>
    plural('it', n, { one: '🔔 Hai {n} domanda senza risposta', other: '🔔 Hai {n} domande senza risposta' }),
  notify_ban_permanent: 'permanentemente',
  notify_ban_until: (date) => `fino al ${date}`,
  notify_ban_msg: (untilPhrase) =>
    `⛔ Sei bloccato su VeylMe ${untilPhrase}. Troppi destinatari hanno segnalato i tuoi messaggi.\nSe pensi si tratti di un errore, puoi presentare ricorso nell'app.`,
  notify_warning_msg:
    '⚠️ Diversi destinatari hanno segnalato i tuoi messaggi. Ancora un po\' e sarai bloccato su VeylMe.',

  // MY QUESTIONS SCREEN + InvitePanel non-premium hint (retention-answer-loop)
  my_questions_title: 'Le mie domande',
  my_questions_empty_title: 'Non hai ancora fatto nessuna domanda',
  my_questions_empty_desc: 'Fai una domanda nella casella di qualcuno — la risposta apparirà qui.',
  my_questions_loading: 'Verifica risposta in corso…',
  my_questions_waiting: 'In attesa di risposta',
  my_questions_answer_label: 'Risposta',
  settings_my_questions: 'Le mie domande',
  ask_sent_find_reply_hint: 'Potrai trovare la risposta più tardi in «Le mie domande».',
  inbox_story_nonpremium_hint: 'Un link nella Story non è cliccabile senza Telegram Premium, quindi mostriamo un codice — condividere in chat è più affidabile.',

  // SESSION EXPIRY SCREEN (work-038)
  session_expired_title: 'Il tuo accesso Telegram è scaduto',
  session_expired_desc: 'Telegram concede l\'accesso all\'app una sola volta, all\'avvio, e questo è già scaduto. Riapri l\'app — il testo che avevi iniziato l\'abbiamo salvato.',
  session_expired_desc_no_storage: 'Il tuo accesso a Telegram è scaduto e devi riaprire l\'app. Non siamo riusciti a salvare il testo che avevi scritto — copialo prima di uscire.',
  session_expired_reopen: 'Riapri',
  session_expired_stuck_title: 'Telegram ha restituito lo stesso vecchio accesso',
  session_expired_stuck_desc: 'Chiudi del tutto l\'app dal menu del bot e riaprila — così Telegram concederà un nuovo accesso.',
  session_auth_failed_title: 'Non è stato possibile confermare l\'accesso',
  session_auth_failed_desc: 'Telegram non ha confermato il tuo accesso all\'app. Chiudi l\'app e riaprila dalla chat con il bot.',
  session_expired_manual_close: 'L\'app non può chiudersi da sola qui — chiudila tu e riaprila dalla chat con il bot.',
  session_expiring_soon: 'Il tuo accesso Telegram sta per scadere. Riapri l\'app per non perdere nulla.',
  my_questions_check_failed: 'Non è stato possibile controllare le risposte. Riprova più tardi.',
  settings_notifications_load_error: 'Non è stato possibile caricare l\'impostazione.',
};
